'use strict';

var React = require('react');


module.exports = React.createClass({

  displayName: 'Line',

  propTypes: {
    fill: React.PropTypes.string,
    path: React.PropTypes.string,
    stroke: React.PropTypes.string,
    strokeWidth: React.PropTypes.number,
    strokeDashArray: React.PropTypes.string,
  },

  getDefaultProps:function() {
    return {
      stroke: '#3182bd',
      fill: 'none',
      strokeWidth: 1,
      className: 'rd3-linechart-path'
    };
  },

  render:function() {
    var props = this.props;
    return (
      React.createElement("path", {
        d: props.path, 
        stroke: props.stroke, 
        strokeWidth: props.strokeWidth, 
        strokeDasharray: props.strokeDashArray, 
        fill: props.fill, 
        className: props.className}
      )
    );
  }

});



//////////////////
// WEBPACK FOOTER
// ./~/react-d3/linechart/Line.js
// module id = 348
// module chunks = 0